import { collides, konami } from './functions';

const GRID = 32;
const PADDLE_WIDTH = GRID * 6;
const BALL_SPEED = 12;

export default class Pong {
  constructor(header) {
    this.header = header;
    this.title = this.header.querySelector('.js-page-title');

    this.start = false;
    this.score = 0;

    this.scoreContainer = document.createElement('div');
    this.scoreContainer.style.position = 'absolute';
    this.scoreContainer.style.top = '7.2rem';
    this.scoreContainer.style.left = '3.2rem';
    this.scoreContainer.style.display = 'none';
    this.scoreContainer.innerHTML = 0;
    this.header.appendChild(this.scoreContainer);

    this.canvas = document.createElement('canvas');
    this.canvas.width = this.header.offsetWidth * 2;
    this.canvas.height = this.header.offsetHeight * 2;
    this.canvas.style.height = '100%';
    this.canvas.style.width = '100%';
    this.canvas.style.position = 'absolute';
    this.canvas.style.top = 0;
    this.canvas.style.left = 0;
    this.canvas.style.bottom = 0;
    this.canvas.style.zIndex = -1;
    this.header.appendChild(this.canvas);

    this.context = this.canvas.getContext('2d');
    this.limitPaddleX = this.canvas.width - PADDLE_WIDTH;
    this.mouseX = this.canvas.width / 2 - PADDLE_WIDTH / 2;

    this.paddle = {
      x: this.canvas.width / 2 - PADDLE_WIDTH / 2,
      y: this.canvas.height - GRID,
      height: GRID,
      width: PADDLE_WIDTH,
      dx: 0,
      dy: 0,
    };

    this.ball = {
      x: this.canvas.width / 2,
      y: this.canvas.height / 2,
      width: GRID,
      height: GRID,
      resetting: false,
      dx: BALL_SPEED,
      dy: -BALL_SPEED,
    };

    this.header.addEventListener('mousemove', this.updateMouse.bind(this));

    if (window.innerWidth > 769) {
      if (document.querySelector('.error404')) {
        setTimeout(() => {
          this.header.addEventListener('mousemove', this.updateMouse);
          this.header.addEventListener('mousemove', this.startGame.bind(this));
          this.scoreContainer.style.display = 'block';
          requestAnimationFrame(this.loop.bind(this));
        }, 2000);
      } else {
        konami(() => {
          this.header.addEventListener('mousemove', this.updateMouse);
          this.header.addEventListener('mousemove', this.startGame.bind(this));
          this.scoreContainer.style.display = 'block';
          requestAnimationFrame(this.loop.bind(this));
        });
      }
    }
  }

  startGame() {
    this.start = true;
  }

  updateMouse(e) {
    this.mouseX = e.clientX;
  }

  getPaddlePosition(mouseX) {
    return (mouseX * this.canvas.width) / window.innerWidth - PADDLE_WIDTH / 2;
  }

  loop() {
    requestAnimationFrame(this.loop.bind(this));
    this.context.fillStyle = 'rgba(0, 0, 0, 1)';
    this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
    this.paddle.x = this.getPaddlePosition(this.mouseX);

    if (this.paddle.x < 0) {
      this.paddle.x = 0;
    } else if (this.paddle.x > this.limitPaddleX) {
      this.paddle.x = this.limitPaddleX;
    }
    this.context.fillStyle = 'white';
    this.context.fillRect(
      this.paddle.x,
      this.paddle.y,
      this.paddle.width,
      this.paddle.height
    );

    if (this.start) {
      this.ball.x += this.ball.dx;
      this.ball.y += this.ball.dy;
    }

    if (this.ball.y < 0) {
      this.ball.y = 0;
      this.ball.dy *= -1;
    }

    if (this.ball.x < 0) {
      this.ball.x = 0;
      this.ball.dx *= -1;
    } else if (this.ball.x > this.canvas.width - GRID) {
      this.ball.x = this.canvas.width - GRID;
      this.ball.dx *= -1;
    }

    // si on perd
    if (this.ball.y > this.canvas.height && !this.ball.resetting) {
      // on reset la position de la balle
      this.ball.resetting = true;
      const savedTitle = this.title.innerHTML;
      this.title.innerHTML = window.translations.defeat;
      this.score = 0;
      this.scoreContainer.innerHTML = this.score;

      setTimeout(() => {
        this.ball.resetting = false;
        this.ball.x = this.canvas.width / 2;
        this.ball.y = this.canvas.height / 2;
        this.title.innerHTML = savedTitle;
      }, 1200);
    }

    if (collides(this.ball, this.paddle)) {
      this.ball.dy *= -1;
      this.ball.y = this.paddle.y - this.ball.height;
      this.score++;
      this.scoreContainer.innerHTML = this.score;
    }

    this.context.fillRect(
      this.ball.x,
      this.ball.y,
      this.ball.width,
      this.ball.height
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/pong.js